"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_html_parser_1 = require("react-html-parser");
var loadingPanel = (React.createElement("div", { className: "k-loading-mask" },
    React.createElement("div", { className: "k-loading-image" }),
    React.createElement("div", { className: "k-loading-color" })));
var InfoParam = /** @class */ (function (_super) {
    __extends(InfoParam, _super);
    function InfoParam(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            AwsApi: '',
            ShowLoader: true
        };
        _this.fetchAwsApi = _this.fetchAwsApi.bind(_this);
        _this.handlebuttonclick = _this.handlebuttonclick.bind(_this);
        return _this;
    }
    InfoParam.prototype.componentDidMount = function () {
        this.fetchAwsApi();
    };
    InfoParam.prototype.fetchAwsApi = function () {
        var _this = this;
        fetch('api/Registration/GetAwsParameters')
            .then(function (response) { return response.text(); })
            .then(function (data) {
            _this.setState({ AwsApi: data });
            _this.setState({ ShowLoader: false });
        }).catch(function (error) {
            console.log(error);
        });
    };
    InfoParam.prototype.handlebuttonclick = function () {
        this.setState({ ShowLoader: true });
        this.fetchAwsApi();
    };
    InfoParam.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", null,
                this.state.ShowLoader && loadingPanel,
                React.createElement("label", { id: "lblAWSparam", className: "parameterAWS" }, react_html_parser_1.default(this.state.AwsApi))),
            React.createElement("div", null,
                React.createElement("button", { className: "awsButton", onClick: this.handlebuttonclick }, "Reload Parameters"))));
    };
    return InfoParam;
}(React.Component));
exports.default = InfoParam;
//# sourceMappingURL=infoparam.js.map